import { combineReducers } from 'redux';
import appReducer from './app/reducers';
import drawReducer from './draw/reducers';
import userReducer from './user/reducers';
import bfiUserReducer from './bfiUser/reducers';
import modalsReducer from './modals/reducers';
import setupCompanyReducer from './setupCompany/reducers';
import applicationReducer from './application/reducers';
import brokerReducer from './broker/reducers';
import brokerClientReducer from './brokerClient/reducers';
import iccaReducer from './icca/reducers';
import snackbarReducer from './snackbar/reducers';
import searchReducer from './search/reducers';
import appraiserReducer from './appraisers/reducers';
import loanReducer from './loan/reducers';
import hmdaReducer from './hmda/reducers';
import borrowerReducer from './borrower/reducers';
import templatesReducer from './templates/reducers';
import noticesReducer from './notices/reducers';
import inspectionsReducer from './inspections/reducers';
import levelReducer from './assessments/level/reducers';
import ruleReducer from './assessments/rule/reducers';
import experiencesReducer from './experiences/reducers';
import adminUsersReducer from './adminUsers/reducers';
import watchlistsReducer from './watchlists/reducers';

export default combineReducers({
    app: appReducer,
    drawState: drawReducer,
    user: userReducer,
    bfiUser: bfiUserReducer,
    modals: modalsReducer,
    setupCompany: setupCompanyReducer,
    application: applicationReducer,
    brokerState: brokerReducer,
    brokerClientState: brokerClientReducer,
    iccaState: iccaReducer,
    snackbar: snackbarReducer,
    searchState: searchReducer,
    appraisers: appraiserReducer,
    loan: loanReducer,
    hmda: hmdaReducer,
    borrower: borrowerReducer,
    templates: templatesReducer,
    notices: noticesReducer,
    inspections: inspectionsReducer,
    levels: levelReducer,
    rules: ruleReducer,
    experiences: experiencesReducer,
    adminUsers: adminUsersReducer,
    watchlists: watchlistsReducer,
});
